// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ye3Ui","col":"styles_col__3cr5Z"};